export const Card = ({
  title,
  children,
  className = ""
}) => {
  return (
    <div className={`summary-card ${className}`}>
      {title && (
        <div className="summary-card-title">
          {title}
        </div>
      )}

      {children}
    </div>
  );
};

export const ProgressBar = ({
  value,
  color
}) => {
  return (
    <div className="progress-bar">
      <div
        className="progress-bar-fill"
        style={{
          width: `${value}%`,
          background: color
        }}
      />
    </div>
  );
};

// SVG 기반 도넛
export const SvgDonutChart = ({ data, strokeWidth = 18, radius = 36 }) => {
  const cx = 50, cy = 50, r = radius, sw = strokeWidth;
  const C = 2 * Math.PI * r;
  // butt linecap + 고정 GAP: 작은 세그먼트도 blob 없이 깔끔한 호로 렌더
  const GAP = 1.5;

  const validData = data.filter((item) => item.percentage > 0);
  const total = validData.reduce((s, i) => s + i.percentage, 0);
  const isEmpty = validData.length === 0;

  let startPct = 0;
  const segments = validData.map((item) => {
    const dashLen = Math.max(0.5, (item.percentage / 100) * C - GAP);
    const dashOffset = C * (1 - startPct / 100) + dashLen;
    startPct += item.percentage;
    return { color: item.color, dashLen, dashOffset };
  });

  if (total < 100) {
    const dashLen = Math.max(0.5, ((100 - total) / 100) * C - GAP);
    const dashOffset = C * (1 - startPct / 100) + dashLen;
    segments.push({ color: '#eaecf4', dashLen, dashOffset });
  }

  return (
    <svg
      className="donut-chart-svg"
      viewBox="0 0 100 100"
      style={{ display: 'block', width: '100%', height: 'auto', overflow: 'visible' }}
    >
      <g transform="rotate(-90 50 50)">
        {isEmpty ? (
          <circle cx={cx} cy={cy} r={r} fill="none" stroke="#eaecf4" strokeWidth={sw} />
        ) : (
          segments.map((seg, i) => (
            <circle
              key={i}
              cx={cx} cy={cy} r={r}
              fill="none"
              stroke={seg.color}
              strokeWidth={sw}
              strokeLinecap="butt"
              strokeDasharray={`${seg.dashLen} ${C}`}
              strokeDashoffset={seg.dashOffset}
            />
          ))
        )}
        <circle cx={cx} cy={cy} r={r - sw / 2} fill="white" />
      </g>
    </svg>
  );
};

export const TimeBar = ({
  label,
  percent,
  color,
  percentShow = true
}) => {
  return (
    <div className="time-bar">
      <div className="time-bar-label">
        {label}
      </div>

      <div className="time-bar-progress">
        <ProgressBar
          value={percent}
          color={color}
        />
      </div>

      {percentShow &&
        <div className="time-bar-percent">
          {percent}%
        </div>
      }
    </div>
  );
};